// extracted by mini-css-extract-plugin
export default {"logo":"Footer_logo__8gbJx","wrapper":"Footer_wrapper__FDEp-","Footer":"Footer_Footer__rVBRr","contact":"Footer_contact__fJjop","a":"Footer_a__+RjK4","icon":"Footer_icon__TbOaW"};